var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useState, useEffect } from "react";
//Language Translation
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { deleteShareCartLink, createCart, getSalesRepBaseData } from "../../reduxStore/actions/salesRepDataAction";
import store from "../../reduxStore/store";
//user credentials
import { getLoggedInRepDetails, getLoggedInRepDetailsFromSession, getSharedCartDetailsByIdService, getProductDetailsByVariantIdsService, } from "../../services/apiServices/salesRepDataService";
import { SharedFunctions } from "../SharedFunctions";
import { SalesRepDataActionType } from "../../reduxStore/actions/actionTypes";
import { useDeviceQueries } from "../../shared/Utilites";
export function CartShareBL() {
    var _this = this;
    var _a;
    var t = useTranslation().t; //* Translation *
    // ** Get Data **
    var dispatch = useDispatch();
    var salesRepData = useSelector(function (state) { return (state.salesRepData ? state.salesRepData : {}); });
    //Currency Symbol
    var _b = getLoggedInRepDetails(), shopCurrency = _b.shopCurrency, currency = _b.currency; //user credentials
    var _c = useState(salesRepData.baseData.SharedCartDetails ? salesRepData.baseData.SharedCartDetails : []), shareCartData = _c[0], setShareCartData = _c[1]; // List of all shared carts
    var _d = useState({}), deleteLink = _d[0], setDeleteLink = _d[1]; // Track deletion status for each cart link
    var _e = useState(""), cartName = _e[0], setCartName = _e[1]; // Name of the cart being created/edited
    var _f = useState(salesRepData.productsData ? salesRepData.productsData : []), products = _f[0], setProducts = _f[1]; // All available products or filtered products
    var _g = useState(""), searchProductInput = _g[0], setSearchProductInput = _g[1]; // Search input value for filtering products
    var _h = useState({}), product_idObject = _h[0], setProduct_idObject = _h[1]; // Map of selected product IDs
    var _j = useState(false), backToShopBtn = _j[0], setBackToShopBtn = _j[1]; // Flag to show/hide back to shop button
    var _k = useState({}), variant_idObject = _k[0], setVariant_idObject = _k[1]; // Map of variant IDs to quantities
    var _l = useState([]), NewselectedArray = _l[0], setNewSelectedArray = _l[1]; // Array of selected products with variants
    var _m = useState({ msg: "", color: "blue" }), createdCartMsg = _m[0], setCreatedCartMsg = _m[1]; // Loading message when creating cart
    var _o = useState(false), alertMsgOpen = _o[0], setAlertMsgOpen = _o[1]; // Control alert snackbar visibility
    var _p = useState(null), deleteConfirmation = _p[0], setDeleteConfirmation = _p[1]; // Anchor element for delete confirmation menu
    var CreateCartBtnDisabled = createdCartMsg.msg === t("cartSharing_CartCreating_Msg"); // Disable create button while creating cart
    var _q = useState(false), searchProductArray = _q[0], setSearchProductArray = _q[1]; // Flag indicating if search results are displayed
    var _r = useState([]), filterProductScroll = _r[0], setFilterProductScroll = _r[1]; // Filtered products for scroll display
    var _s = useState(), deleteShareCartDataObject = _s[0], setDeleteShareCartDataObject = _s[1]; // Cart data object for deletion confirmation
    var _t = useState({}), isError = _t[0], setIsError = _t[1]; // Error state for form validation
    var _u = useState({ msg: "", open: false, severity: "error" }), alertErrorMsg = _u[0], setAlertErrorMsg = _u[1]; // Error/success alert message
    var isMobile = useDeviceQueries(); // mobile view
    var _v = useState(((_a = salesRepData === null || salesRepData === void 0 ? void 0 : salesRepData.productsData) === null || _a === void 0 ? void 0 : _a.length) > 0 ? false : true), productsLoading = _v[0], setProductsLoading = _v[1]; // Loading state for products
    var useInfiniteScroll = SharedFunctions().useInfiniteScroll;
    var _w = useState(0), useEffectCount = _w[0], setUseEffectCount = _w[1]; // Counter to track useEffect executions
    var _x = useState(10), cartSharingProductsRowsPerPage = _x[0], setCartSharingProductsRowsPerPage = _x[1]; // Number of products per page for pagination
    var cartSharingInnerScroll = useInfiniteScroll(cartSharingProductsRowsPerPage, setCartSharingProductsRowsPerPage, products); // Infinite scroll handler
    var _y = useState(false), openSearchProducts = _y[0], setOpenSearchProducts = _y[1]; // Control product search modal visibility
    var _z = useState(false), isRemoveSelectedProduct = _z[0], setIsRemoveSelectedProduct = _z[1]; // Flag to trigger selected product removal
    var _0 = useState(false), isRemoveCartPopup = _0[0], setIsRemoveCartPopup = _0[1]; // Control clear cart confirmation popup
    var _1 = useState(null), previewCartDetails = _1[0], setPreviewCartDetails = _1[1]; // Cart details for preview modal
    var _2 = useState(false), previewLoading = _2[0], setPreviewLoading = _2[1]; // Loading state for cart preview
    var _3 = useState(false), isEditMode = _3[0], setIsEditMode = _3[1]; // Flag indicating if cart is being edited
    var _4 = useState(null), editingCart = _4[0], setEditingCart = _4[1]; // Cart data being edited
    var _5 = useState({}), menuAnchor = _5[0], setMenuAnchor = _5[1]; // Anchor element for menu positioning
    var _6 = useState(null), previewCart = _6[0], setPreviewCart = _6[1]; // Cart data for preview
    var _7 = useState(false), openPreview = _7[0], setOpenPreview = _7[1]; // Control preview dialog visibility
    var _8 = useState(false), quantityAdjustedWarningOpen = _8[0], setQuantityAdjustedWarningOpen = _8[1]; // Control quantity adjustment warning visibility
    var _9 = useState(false), showQuantityAdjustedBanner = _9[0], setShowQuantityAdjustedBanner = _9[1]; // Control quantity adjustment banner visibility in edit mode
    useEffect(function () {
        var _a;
        setProductsLoading(!((_a = salesRepData === null || salesRepData === void 0 ? void 0 : salesRepData.baseData) === null || _a === void 0 ? void 0 : _a.completedGetProductApi)); // Set loading state based on API completion status
    }, []);
    useEffect(function () {
        var _a;
        if (((_a = salesRepData === null || salesRepData === void 0 ? void 0 : salesRepData.productsData) === null || _a === void 0 ? void 0 : _a.length) > 0)
            setProducts(salesRepData === null || salesRepData === void 0 ? void 0 : salesRepData.productsData); // Update products when data is available
        setUseEffectCount(function (prev) {
            if (prev === 1)
                setProductsLoading(false); // Stop loading after first data load
            return prev + 1;
        });
    }, [salesRepData.productsData]);
    // Check for cartuniqueid in URL and auto-load cart
    useEffect(function () {
        var urlParams = new URLSearchParams(window.location.search);
        var cartUniqueId = urlParams.get("cartuniqueid");
        if (cartUniqueId && !openPreview) {
            // Auto-open preview and load cart details
            setOpenPreview(true);
            getSharedCartDetailsById(cartUniqueId, true);
            // Set a mock cart object for preview display
            setPreviewCart({
                CartUniqueId: cartUniqueId,
                CartName: "Loading...",
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // Update previewCart name when cart details are loaded
    useEffect(function () {
        if (previewCartDetails === null || previewCartDetails === void 0 ? void 0 : previewCartDetails.CartName) {
            var cartUniqueId_1 = previewCartDetails.CartUniqueId || (previewCart === null || previewCart === void 0 ? void 0 : previewCart.CartUniqueId);
            if (cartUniqueId_1) {
                setPreviewCart(function (prev) { return (__assign(__assign({}, prev), { CartName: previewCartDetails.CartName, CartUniqueId: cartUniqueId_1 })); });
            }
        }
    }, [previewCartDetails, previewCart]);
    useEffect(function () {
        if (backToShopBtn === true) {
            // For Selected Table Refereshing
            return handleSelectedBtn();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [variant_idObject, NewselectedArray]);
    // Show warning snackbar when quantities are adjusted
    useEffect(function () {
        if (hasQuantityAdjusted()) {
            setQuantityAdjustedWarningOpen(true);
        }
        else {
            setQuantityAdjustedWarningOpen(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [variant_idObject, NewselectedArray]);
    // Close menu on scroll - close immediately when any scroll happens
    useEffect(function () {
        var handleScroll = function () {
            // Close all open menus immediately when scrolling
            setMenuAnchor({});
        };
        // Listen to scroll events on window and all scrollable elements
        window.addEventListener("scroll", handleScroll, true);
        document.addEventListener("scroll", handleScroll, true);
        // Also listen to wheel events for immediate response
        var handleWheel = function () {
            setMenuAnchor({});
        };
        window.addEventListener("wheel", handleWheel, { passive: true });
        return function () {
            window.removeEventListener("scroll", handleScroll, true);
            document.removeEventListener("scroll", handleScroll, true);
            window.removeEventListener("wheel", handleWheel);
        };
    }, []);
    // Helper function to find product and variant in productsData
    var findProductAndVariantInProductsData = function (normalizedVariantId, originalVariantId, productsData) {
        for (var _i = 0, productsData_1 = productsData; _i < productsData_1.length; _i++) {
            var product = productsData_1[_i];
            for (var _a = 0, _b = product.variants || []; _a < _b.length; _a++) {
                var variant = _b[_a];
                var normalizedVariantIdFromProduct = normalizeVariantId(variant.variantId);
                if (normalizedVariantIdFromProduct === normalizedVariantId || variant.variantId === originalVariantId) {
                    return { foundProduct: product, foundVariant: variant };
                }
            }
        }
        return { foundProduct: null, foundVariant: null };
    };
    useEffect(function () {
        if (!(salesRepData === null || salesRepData === void 0 ? void 0 : salesRepData.cartShareProductData) || !Array.isArray(salesRepData.cartShareProductData) || salesRepData.cartShareProductData.length === 0)
            return;
        var processedCartItems = salesRepData.cartShareProductData
            .map(function (cartItem) {
            var variantId = cartItem.id;
            var quantity = cartItem.quantity || 1;
            if (!variantId)
                return null;
            var normalizedVariantId = normalizeVariantId(variantId);
            if (normalizedVariantId === null)
                return null;
            // Common variable: find product and variant (filter out deleted products)
            var _a = findProductAndVariantInProductsData(normalizedVariantId, variantId, salesRepData.productsData || []), foundProduct = _a.foundProduct, foundVariant = _a.foundVariant;
            if (foundProduct && foundVariant && foundProduct.productId) {
                return {
                    normalizedVariantId: normalizedVariantId,
                    foundProduct: foundProduct,
                    foundVariant: foundVariant,
                    quantity: quantity,
                    productId: foundProduct.productId,
                };
            }
            return null;
        })
            .filter(function (item) { return item !== null; });
        setNewSelectedArray(function (prevArray) {
            var currentProducts = prevArray;
            var productMap = {}; // Map to avoid duplicate products
            // Preserve existing products
            currentProducts.forEach(function (product) {
                if (product.productId) {
                    productMap[product.productId] = __assign(__assign({}, product), { variants: __spreadArray([], (product.variants || []), true) }); // Shallow copy with variant array copy
                }
            });
            // Build productMap from processed items
            processedCartItems.forEach(function (item) {
                if (!productMap[item.foundProduct.productId]) {
                    productMap[item.foundProduct.productId] = __assign(__assign({}, item.foundProduct), { variants: [] });
                }
                if (!productMap[item.foundProduct.productId].variants.some(function (v) { return normalizeVariantId(v.variantId) === item.normalizedVariantId; })) {
                    productMap[item.foundProduct.productId].variants.push(item.foundVariant);
                }
            });
            var newSelectedArray = Object.values(productMap);
            return newSelectedArray;
        });
        setVariant_idObject(function (prevVariantObject) {
            var currentVariantObject = prevVariantObject;
            var newVariantIdObject = __assign({}, currentVariantObject);
            processedCartItems.forEach(function (item) {
                newVariantIdObject[item.normalizedVariantId] = item.quantity;
            });
            return newVariantIdObject;
        });
        setProduct_idObject(function (prevProductObject) {
            var currentProductObject = prevProductObject;
            var newProductIdObject = __assign({}, currentProductObject);
            processedCartItems.forEach(function (item) {
                newProductIdObject[item.productId] = item.productId;
            });
            // Set state with calculated value
            return newProductIdObject;
        });
    }, [salesRepData === null || salesRepData === void 0 ? void 0 : salesRepData.cartShareProductData]);
    var getSharedCartDetailsById = function (cartUniqueId, forceRefresh) {
        if (forceRefresh === void 0) { forceRefresh = false; }
        return __awaiter(_this, void 0, void 0, function () {
            var responseData, parsedCartProductDetails, parsed, storefrontAccessToken, variantIds, productDetails_1, enrichedCartItems, error_1, formattedCartItems, e_1;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 9, 10, 11]);
                        setPreviewLoading(true);
                        setPreviewCartDetails(null);
                        if (!cartUniqueId) {
                            setAlertErrorMsg({ msg: t("cartSharing_CartCreateError_Msg") || "Error: Cart ID is missing", open: true, severity: "error" });
                            setPreviewLoading(false);
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, getSharedCartDetailsByIdService(cartUniqueId, forceRefresh)];
                    case 1:
                        responseData = _b.sent();
                        if (!responseData) return [3 /*break*/, 7];
                        parsedCartProductDetails = [];
                        // Handle CartProductDetails - it can be string, array, or null
                        if (responseData.CartProductDetails) {
                            if (typeof responseData.CartProductDetails === "string") {
                                try {
                                    parsed = JSON.parse(responseData.CartProductDetails);
                                    parsedCartProductDetails = Array.isArray(parsed) ? parsed : [];
                                }
                                catch (error) {
                                    parsedCartProductDetails = []; // Return empty array on parse error
                                }
                            }
                            else if (responseData.CartProductDetails === null) {
                                parsedCartProductDetails = [];
                            }
                        }
                        if (!(parsedCartProductDetails.length > 0)) return [3 /*break*/, 6];
                        storefrontAccessToken = (_a = salesRepData.baseData) === null || _a === void 0 ? void 0 : _a.storefrontAccessToken;
                        if (!storefrontAccessToken) return [3 /*break*/, 5];
                        variantIds = parsedCartProductDetails
                            .map(function (item) {
                            var id = item.id || item.variantId;
                            if (typeof id === "number")
                                return id;
                            if (typeof id === "string") {
                                var numId = parseInt(id, 10); // Convert string to number
                                return isNaN(numId) ? null : numId;
                            }
                            return null;
                        })
                            .filter(function (id) { return id !== null && typeof id === "number" && !isNaN(id); });
                        if (!(variantIds.length > 0)) return [3 /*break*/, 5];
                        _b.label = 2;
                    case 2:
                        _b.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, getProductDetailsByVariantIdsService(variantIds, storefrontAccessToken)];
                    case 3:
                        productDetails_1 = _b.sent();
                        enrichedCartItems = parsedCartProductDetails
                            .map(function (cartItem) {
                            var _a, _b, _c, _d, _e, _f, _g, _h;
                            var variantId = cartItem.id || cartItem.variantId;
                            var numericVariantId = typeof variantId === "string" ? parseInt(variantId, 10) : variantId;
                            var productDetail = productDetails_1.find(function (pd) {
                                if (!pd || !pd.id)
                                    return false;
                                var pdVariantId = pd.id.split("/").pop(); // Extract variant ID from Shopify GID
                                return pdVariantId === String(numericVariantId) || pd.id === "gid://shopify/ProductVariant/".concat(numericVariantId);
                            });
                            if (productDetail) {
                                var imageUrl = ((_a = productDetail.image) === null || _a === void 0 ? void 0 : _a.url) || ((_f = (_e = (_d = (_c = (_b = productDetail.product) === null || _b === void 0 ? void 0 : _b.images) === null || _c === void 0 ? void 0 : _c.edges) === null || _d === void 0 ? void 0 : _d[0]) === null || _e === void 0 ? void 0 : _e.node) === null || _f === void 0 ? void 0 : _f.url) || null; // Get product image
                                var originalQuantity = cartItem.quantity || cartItem.Quantity || 0;
                                var quantityAvailable = productDetail.quantityAvailable;
                                var adjustedQuantity = originalQuantity;
                                var isQuantityAdjusted = false;
                                if (quantityAvailable !== null && quantityAvailable < originalQuantity) {
                                    adjustedQuantity = Math.max(0, quantityAvailable); // Adjust quantity to available inventory
                                    isQuantityAdjusted = true; // Mark as adjusted
                                }
                                if (!productDetail.availableForSale || (quantityAvailable !== null && quantityAvailable === 0)) {
                                    adjustedQuantity = 0; // Set to 0 if not available for sale
                                    isQuantityAdjusted = originalQuantity > 0; // Mark as adjusted if original was > 0
                                }
                                return __assign(__assign({}, cartItem), { VariantId: productDetail.id, ProductTitle: ((_g = productDetail.product) === null || _g === void 0 ? void 0 : _g.title) || cartItem.handle || "-", Price: Number(((_h = productDetail.price) === null || _h === void 0 ? void 0 : _h.amount) || 0), Quantity: adjustedQuantity, OriginalQuantity: originalQuantity, ImageUrl: imageUrl, quantityAvailable: quantityAvailable, availableForSale: productDetail.availableForSale, isQuantityAdjusted: isQuantityAdjusted });
                            }
                            // Return null for deleted products (not found in Shopify) - will be filtered out
                            return null;
                        })
                            .filter(function (item) { return item !== null; });
                        setPreviewCartDetails(__assign(__assign({}, responseData), { CartProductDetails: enrichedCartItems })); // Set enriched cart details
                        return [2 /*return*/];
                    case 4:
                        error_1 = _b.sent();
                        setAlertErrorMsg({
                            msg: t("cartSharing_ProductDetailsError_Msg") || "Error fetching product details. Showing basic cart information.",
                            open: true,
                            severity: "warning",
                        });
                        return [3 /*break*/, 5];
                    case 5:
                        formattedCartItems = parsedCartProductDetails.map(function (cartItem) { return (__assign(__assign({}, cartItem), { VariantId: cartItem.id || cartItem.variantId, ProductTitle: cartItem.handle || cartItem.title || cartItem.ProductTitle || "Product ".concat(cartItem.id || cartItem.variantId || "Unknown"), Price: cartItem.price || cartItem.Price || 0, Quantity: cartItem.quantity !== undefined ? cartItem.quantity : cartItem.Quantity, ImageUrl: cartItem.imageUrl || cartItem.ImageUrl || null })); });
                        setPreviewCartDetails(__assign(__assign({}, responseData), { CartProductDetails: formattedCartItems })); // Set formatted cart details
                        return [2 /*return*/];
                    case 6:
                        setPreviewCartDetails(__assign(__assign({}, responseData), { CartProductDetails: parsedCartProductDetails.length > 0 ? parsedCartProductDetails : [] }));
                        return [3 /*break*/, 8];
                    case 7:
                        // Response is invalid - could be false, null, or not an object
                        setAlertErrorMsg({ msg: t("cartSharing_CartCreateError_Msg") || "Error: Unable to load cart details", open: true, severity: "error" });
                        setPreviewCartDetails(null);
                        _b.label = 8;
                    case 8: return [3 /*break*/, 11];
                    case 9:
                        e_1 = _b.sent();
                        setAlertErrorMsg({ msg: t("cartSharing_CartCreateError_Msg") || "Error: Failed to load cart details", open: true, severity: "error" });
                        setPreviewCartDetails(null);
                        return [3 /*break*/, 11];
                    case 10:
                        setPreviewLoading(false); // Hide loading indicator
                        return [7 /*endfinally*/];
                    case 11: return [2 /*return*/];
                }
            });
        });
    };
    var SearchProduct = function (value) {
        var _a, _b;
        setCartSharingProductsRowsPerPage(10); // Reset pagination
        if (((_a = salesRepData.productsData) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            var searchValue_1 = value.trim().toLowerCase();
            var filteredRows = (_b = salesRepData.productsData) === null || _b === void 0 ? void 0 : _b.filter(function (product) {
                var _a, _b;
                var product_Title = (_b = (_a = product === null || product === void 0 ? void 0 : product.productTitle) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === null || _b === void 0 ? void 0 : _b.includes(searchValue_1); // Search in product title
                var variant_Title = product === null || product === void 0 ? void 0 : product.variants.some(function (v) { var _a; return (_a = v.variantTitle.toLowerCase()) === null || _a === void 0 ? void 0 : _a.includes(searchValue_1); }); // Search in variant title
                var variant_Sku = product === null || product === void 0 ? void 0 : product.variants.some(function (v) { var _a; return (_a = (v.sku || "").toLowerCase()) === null || _a === void 0 ? void 0 : _a.includes(searchValue_1); }); // Search in SKU
                var variant_Price = product === null || product === void 0 ? void 0 : product.variants.some(function (v) { return Number(v.variantPrice) === Number(value.trim()); }); // Search by exact price match
                return product_Title || variant_Title || variant_Sku || variant_Price; // Return if any match found
            });
            setFilterProductScroll(filteredRows); // Store filtered results for scroll
            setSearchProductArray(!!filterProductScroll); // Set flag if search results exist
            setProducts(filteredRows); // Update products list with filtered results
        }
    };
    var renderImageSrc = function (image_id, productImages) {
        var _a;
        if (image_id && (productImages === null || productImages === void 0 ? void 0 : productImages.length)) {
            var foundImg = productImages.find(function (img) { return img.imageId === image_id; }); // Find image by ID
            if (foundImg)
                return foundImg.src || "image";
        }
        return (_a = productImages[0]) === null || _a === void 0 ? void 0 : _a.src; // Return first image as fallback
    };
    var handleSelectedBtn = function () {
        setBackToShopBtn(true); // Show back to shop button
        setSearchProductArray(false); // Clear search results flag
        setProducts(NewselectedArray); // Display only selected products
        setCartSharingProductsRowsPerPage(10); // Reset pagination
    };
    var handleBackToShopBtn = function () {
        setProducts((salesRepData === null || salesRepData === void 0 ? void 0 : salesRepData.productsData) || []); // Show all products again
        setBackToShopBtn(false); // Hide back to shop button
        setCartSharingProductsRowsPerPage(10); // Reset pagination
        if (searchProductInput)
            setSearchProductInput(""); // Clear search input
    };
    var handleQuantity_IncrementDecrement = function (variantId, actionType) {
        if (!variantId || !actionType) {
            setAlertMsgOpen(true); // Show error if invalid input
            return;
        }
        var Variant_idObject = __assign({}, variant_idObject);
        Variant_idObject[variantId] = actionType === "add" ? parseInt(variant_idObject[variantId]) + 1 : Math.max(variant_idObject[variantId] - 1, 1); // Increment or decrement quantity (min 1)
        setVariant_idObject(Variant_idObject);
    };
    var handleProductQuantity = function (e, variantId) {
        var _a;
        if (!variantId) {
            setAlertMsgOpen(true); // Show error if variant ID missing
            return;
        }
        var _b = e.target, name = _b.name, value = _b.value;
        if (value === "")
            setAlertErrorMsg({ msg: t("productTable_error_AlertMsg2"), open: true }); // Show error for empty value
        if (!checkQuantityValidation(name, value)) {
            setVariant_idObject(__assign(__assign({}, variant_idObject), (_a = {}, _a[variantId] = value === "0" ? "" : value, _a))); // Update quantity (clear if 0)
        }
    };
    var checkQuantityValidation = function (name, value) {
        if (parseInt(value) <= 0) {
            setAlertErrorMsg({ msg: t("productTable_error_AlertMsg"), open: true }); // Show error for invalid quantity
            return true; // Return true if validation failed
        }
        return false; // Return false if validation passed
    };
    var deleteSharedCartLink = function () { return __awaiter(_this, void 0, void 0, function () {
        var CartUniqueId, Id, _a, CustomerId, SalesRepName, deleteObject, deleteLinkSuccessfully;
        var _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    CartUniqueId = deleteShareCartDataObject === null || deleteShareCartDataObject === void 0 ? void 0 : deleteShareCartDataObject.delete_Cart_Link_Id;
                    Id = deleteShareCartDataObject === null || deleteShareCartDataObject === void 0 ? void 0 : deleteShareCartDataObject.delete_Cart_Id;
                    if (!CartUniqueId || !Id) {
                        setAlertMsgOpen(true); // Show error if IDs missing
                        return [2 /*return*/];
                    }
                    _a = getLoggedInRepDetailsFromSession(), CustomerId = _a.CustomerId, SalesRepName = _a.SalesRepName;
                    deleteObject = __assign(__assign({}, deleteLink), (_b = {}, _b[Id] = true, _b));
                    setDeleteLink(deleteObject);
                    return [4 /*yield*/, dispatch(deleteShareCartLink({ salesRepName: SalesRepName, SalesrepId: CustomerId, cartUniqueId: CartUniqueId }))];
                case 1:
                    deleteLinkSuccessfully = _d.sent();
                    if (deleteLinkSuccessfully) {
                        delete deleteLink[Id]; // Remove from delete tracking on success
                        setDeleteConfirmation(null); // Close confirmation dialog
                    }
                    else {
                        setDeleteLink(__assign(__assign({}, deleteObject), (_c = {}, _c[Id] = false, _c))); // Mark as failed
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var openDeleteConfirmation = function (event, SharedCart, index) {
        setDeleteConfirmation(event.currentTarget); // Set anchor element for menu
        setDeleteShareCartDataObject({ delete_Cart_Link_Id: SharedCart === null || SharedCart === void 0 ? void 0 : SharedCart.CartUniqueId, delete_index: index, delete_Cart_Id: SharedCart === null || SharedCart === void 0 ? void 0 : SharedCart.Id }); // Store cart data for deletion
    };
    //create cart
    var createSharedCart = function () { return __awaiter(_this, void 0, void 0, function () {
        var _a, CustomerId, SalesRepName, customerFirstName, customerId, productDetails, reduxCartData, reduxProductDetails, errorMsg, data, post_Data, responseData, successMsg, updatedCartUniqueId_1;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _a = getLoggedInRepDetailsFromSession(), CustomerId = _a.CustomerId, SalesRepName = _a.SalesRepName;
                    customerFirstName = SalesRepName;
                    customerId = CustomerId;
                    productDetails = [];
                    reduxCartData = (_b = store.getState().salesRepData) === null || _b === void 0 ? void 0 : _b.cartShareProductData;
                    reduxProductDetails = Array.isArray(reduxCartData) ? reduxCartData : [];
                    // Use Redux data if available (for edit mode), otherwise use local state
                    if (cartName.trim() !== "" && (reduxProductDetails === null || reduxProductDetails === void 0 ? void 0 : reduxProductDetails.length) > 0) {
                        productDetails = reduxProductDetails.map(function (item) { return (__assign({ id: item.id, quantity: item.quantity || 1, handle: item.handle || "" }, (item.selling_plan && { selling_plan: item.selling_plan }))); });
                    }
                    else if (cartName.trim() !== "" && (NewselectedArray === null || NewselectedArray === void 0 ? void 0 : NewselectedArray.length) > 0) {
                        NewselectedArray === null || NewselectedArray === void 0 ? void 0 : NewselectedArray.forEach(function (product) {
                            var _a;
                            (_a = product === null || product === void 0 ? void 0 : product.variants) === null || _a === void 0 ? void 0 : _a.forEach(function (variant) {
                                var normalizedVariantId = normalizeVariantId(variant.variantId); // Normalize variant ID
                                var quantity = normalizedVariantId !== null && variant_idObject[normalizedVariantId] !== undefined
                                    ? variant_idObject[normalizedVariantId] // Use normalized ID if available
                                    : variant_idObject[variant.variantId] !== undefined
                                        ? variant_idObject[variant.variantId] // Fallback to original ID
                                        : 1; // Default quantity
                                productDetails.push({ id: variant.variantId, quantity: quantity, handle: product.handle }); // Add product to cart data
                            });
                        });
                    }
                    else if (cartName.trim() !== "" && Object.keys(variant_idObject).length > 0) {
                        Object.keys(variant_idObject).forEach(function (variantIdKey) {
                            var quantity = variant_idObject[variantIdKey];
                            if (quantity && quantity > 0) {
                                productDetails.push({ id: parseInt(variantIdKey) || variantIdKey, quantity: quantity, handle: "" }); // Add variant directly if no product array
                            }
                        });
                    }
                    if (cartName.trim() === "" || (productDetails === null || productDetails === void 0 ? void 0 : productDetails.length) === 0) {
                        errorMsg = cartName.trim() === "" ? t("productnotselectforcartsharinglbl1") : t("productnotselectforcartsharinglbl2");
                        setAlertErrorMsg({ msg: errorMsg, open: true });
                        return [2 /*return*/];
                    }
                    data = {
                        salesRepName: customerFirstName,
                        SalesrepId: customerId,
                        cartName: cartName,
                        cartdata: JSON.stringify(productDetails), // Stringify product details for API
                    };
                    // If in edit mode, include cart ID to update existing cart
                    if (isEditMode && editingCart) {
                        data.cartUniqueId = editingCart.CartUniqueId; // Include unique ID for update
                        data.cartId = editingCart.Id; // Include cart ID for update
                    }
                    post_Data = JSON.stringify(data);
                    setCreatedCartMsg({ msg: t("cartSharing_CartCreating_Msg"), color: "blue" }); // Show loading message
                    return [4 /*yield*/, dispatch(createCart(post_Data))];
                case 1:
                    responseData = _c.sent();
                    if (!(responseData && responseData.data === true)) return [3 /*break*/, 3];
                    successMsg = isEditMode ? t("cartSharing_CartUpdatedSuccessfully_Msg") || "Your cart has been updated successfully" : t("cartSharing_CartCreatedSuccessfully_Msg");
                    setAlertErrorMsg({ msg: successMsg, open: true, severity: "success" });
                    setNewSelectedArray([]); // Clear selected products
                    setVariant_idObject({}); // Clear variant quantities
                    setProduct_idObject({}); // Clear product IDs
                    setCartName(""); // Clear cart name
                    updatedCartUniqueId_1 = isEditMode && editingCart ? editingCart.CartUniqueId : null;
                    if (isEditMode) {
                        setIsEditMode(false); // Exit edit mode
                        setEditingCart(null); // Clear editing cart data
                    }
                    setPreviewCartDetails(null); // Clear preview
                    setTimeout(function () {
                        setCreatedCartMsg({ msg: "", color: "" }); // Clear loading message
                        setAlertErrorMsg({ msg: "", open: false }); // Clear success message
                    }, 2000);
                    return [4 /*yield*/, dispatch(getSalesRepBaseData())];
                case 2:
                    _c.sent(); // Refresh base data
                    dispatch({
                        payload: { cartCreatedSuccessFully: true },
                        type: SalesRepDataActionType.CART_SHARE_PRODUCT_DATA, // Dispatch action to clear cart share product data
                    });
                    setShareCartData(store.getState().salesRepData.baseData.SharedCartDetails); // Update shared cart list
                    if (updatedCartUniqueId_1) {
                        setTimeout(function () { return getSharedCartDetailsById(updatedCartUniqueId_1, true); }, 1500); // Refresh preview after update
                    }
                    return [2 /*return*/, updatedCartUniqueId_1];
                case 3:
                    if (responseData !== null && responseData !== undefined) {
                        setAlertErrorMsg({ msg: t("cartSharing_CartCreateError_Msg"), open: true, severity: "error" }); // Show error message
                        setTimeout(function () {
                            setAlertErrorMsg({ msg: "", open: false });
                            setCreatedCartMsg({ msg: "", color: "" }); // Clear messages after timeout
                        }, 3000);
                        return [2 /*return*/, null];
                    }
                    _c.label = 4;
                case 4: return [2 /*return*/, null];
            }
        });
    }); };
    var normalizeVariantId = function (variantId) {
        if (variantId === null || variantId === undefined)
            return null;
        if (typeof variantId === "string") {
            var gidMatch = String(variantId).match(/ProductVariant\/(\d+)/); // Extract ID from Shopify GID format (gid://shopify/ProductVariant/123)
            if (gidMatch)
                return parseInt(gidMatch[1]); // Return extracted numeric ID
            var parsed = parseInt(String(variantId)); // Try parsing as plain number string
            return isNaN(parsed) ? null : parsed;
        }
        return typeof variantId === "number" ? variantId : null; // Return as-is if already a number
    };
    var checkUncheck = function (event, selectType, productObject, variantObject) {
        var _a, _b, _c;
        if (!productObject || ((_a = Object.keys(productObject)) === null || _a === void 0 ? void 0 : _a.length) === 0 || !((_b = productObject.variants) === null || _b === void 0 ? void 0 : _b.length)) {
            setAlertMsgOpen(true); // Show error if invalid product
            return;
        }
        var checked = event.target.checked;
        var TempProduct_idObject = __assign({}, product_idObject); // Copy product ID map
        var TempVariant_idObject = __assign({}, variant_idObject); // Copy variant quantity map
        var TempProductObject = JSON.parse(JSON.stringify(productObject)); // Deep copy product
        var TempVariantObject = variantObject ? JSON.parse(JSON.stringify(variantObject)) : {}; // Deep copy variant if provided
        var updateVariantObject = function (variants) {
            variants.forEach(function (variant) {
                var normalizedId = normalizeVariantId(variant.variantId); // Normalize variant ID
                if (normalizedId !== null)
                    TempVariant_idObject[normalizedId] = TempVariant_idObject[normalizedId] || 1; // Set default quantity 1
            });
        };
        if (selectType === "isProduct") {
            if (checked) {
                if (isNotEmpty(product_idObject[productObject.productId])) {
                    setNewSelectedArray(function (prevArray) { return prevArray.map(function (p) { return (p.productId === productObject.productId ? __assign(__assign({}, p), { variants: TempProductObject.variants }) : p); }); }); // Update existing product variants
                    updateVariantObject(TempProductObject.variants); // Update variant quantities
                    setVariant_idObject(__assign({}, TempVariant_idObject));
                }
                else {
                    setNewSelectedArray(function (prevArray) { return __spreadArray(__spreadArray([], prevArray, true), [TempProductObject], false); }); // Add new product
                    TempProduct_idObject[productObject.productId] = productObject.productId; // Track product ID
                    setProduct_idObject(__assign({}, TempProduct_idObject));
                    updateVariantObject(TempProductObject.variants); // Set variant quantities
                    setVariant_idObject(__assign({}, TempVariant_idObject));
                }
            }
            else {
                setNewSelectedArray(function (prevArray) { return prevArray.filter(function (p) { return p.productId !== productObject.productId; }); }); // Remove product
                delete TempProduct_idObject[productObject.productId]; // Remove from tracking
                (_c = TempProductObject.variants) === null || _c === void 0 ? void 0 : _c.forEach(function (variant) {
                    var normalizedId = normalizeVariantId(variant.variantId);
                    if (normalizedId !== null)
                        delete TempVariant_idObject[normalizedId]; // Remove variant quantities
                });
                setProduct_idObject(__assign({}, TempProduct_idObject));
                setVariant_idObject(__assign({}, TempVariant_idObject));
            }
        }
        else {
            if (checked) {
                if (isNotEmpty(product_idObject[productObject.productId])) {
                    setNewSelectedArray(function (prevArray) { return prevArray.map(function (p) { return (p.productId === productObject.productId ? __assign(__assign({}, p), { variants: __spreadArray(__spreadArray([], p.variants, true), [__assign(__assign({}, TempVariantObject), { quantity: 1 })], false) }) : p); }); } // Add variant to existing product
                    );
                    var normalizedId = normalizeVariantId(variantObject.variantId);
                    if (normalizedId !== null)
                        TempVariant_idObject[normalizedId] = TempVariant_idObject[normalizedId] || 1; // Set quantity
                    setVariant_idObject(__assign({}, TempVariant_idObject));
                }
                else {
                    setNewSelectedArray(function (prevArray) { return __spreadArray(__spreadArray([], prevArray, true), [__assign(__assign({}, TempProductObject), { variants: [TempVariantObject] })], false); }); // Add product with single variant
                    TempProduct_idObject[productObject.productId] = productObject.productId;
                    setProduct_idObject(__assign({}, TempProduct_idObject));
                    var normalizedId = normalizeVariantId(variantObject.variantId);
                    if (normalizedId !== null)
                        TempVariant_idObject[normalizedId] = TempVariant_idObject[normalizedId] || 1;
                    setVariant_idObject(__assign({}, TempVariant_idObject));
                }
            }
            else {
                setNewSelectedArray(function (prevArray) {
                    var updatedArray = prevArray.map(function (p) {
                        var _a;
                        return (__assign(__assign({}, p), { variants: ((_a = p.variants) === null || _a === void 0 ? void 0 : _a.filter(function (v) { return v.variantId !== variantObject.variantId; })) || [] }));
                    });
                    var filteredArray = updatedArray.filter(function (p) {
                        var _a, _b;
                        if (((_a = p === null || p === void 0 ? void 0 : p.variants) === null || _a === void 0 ? void 0 : _a.length) >= 1)
                            return true; // Keep products with variants
                        if (((_b = p === null || p === void 0 ? void 0 : p.variants) === null || _b === void 0 ? void 0 : _b.length) === 0)
                            delete TempProduct_idObject[p === null || p === void 0 ? void 0 : p.productId]; // Remove product if no variants left
                        return false;
                    });
                    setProduct_idObject(__assign({}, TempProduct_idObject));
                    return filteredArray;
                });
                var normalizedId = normalizeVariantId(variantObject.variantId);
                if (normalizedId !== null)
                    delete TempVariant_idObject[normalizedId]; // Remove variant quantity
                setVariant_idObject(__assign({}, TempVariant_idObject));
            }
        }
    };
    var handleAlertMsgClose = function (event, reason) {
        if (reason === "clickaway")
            return; // Don't close on clickaway
        setAlertMsgOpen(false); // Close alert
        setAlertErrorMsg({ msg: "", open: false }); // Clear error message
    };
    var isNotEmpty = function (params) { return params !== null && params !== undefined; }; // Check if value is not null/undefined
    var handleDisableCreateCartBtn = function () {
        var productDetails = Array.isArray(salesRepData.cartShareProductData) ? salesRepData.cartShareProductData : []; // Get existing cart data
        if (cartName.trim() !== "" && (NewselectedArray === null || NewselectedArray === void 0 ? void 0 : NewselectedArray.length) > 0) {
            NewselectedArray === null || NewselectedArray === void 0 ? void 0 : NewselectedArray.forEach(function (product) {
                var _a;
                (_a = product === null || product === void 0 ? void 0 : product.variants) === null || _a === void 0 ? void 0 : _a.forEach(function (variant) {
                    productDetails.push({ id: variant.variantId, quantity: variant_idObject[variant.variantId], handle: product === null || product === void 0 ? void 0 : product.handle }); // Add selected products
                });
            });
        }
        return (productDetails === null || productDetails === void 0 ? void 0 : productDetails.length) === 0; // Disable button if no products selected
    };
    var disableCreateCartBtn = handleDisableCreateCartBtn(); // Compute disable state
    var populateFormWithCartData = function (cartData) {
        var _a;
        if (!cartData || !cartData.CartProductDetails || !Array.isArray(cartData.CartProductDetails))
            return; // Validate cart data
        setNewSelectedArray([]); // Clear existing selections
        setVariant_idObject({}); // Clear variant quantities
        setProduct_idObject({}); // Clear product IDs
        setCartName(cartData.CartName || ""); // Set cart name
        // Check if any products have adjusted quantities
        var hasQuantityAdjustments = (_a = cartData.CartProductDetails) === null || _a === void 0 ? void 0 : _a.some(function (item) { return (item === null || item === void 0 ? void 0 : item.isQuantityAdjusted) === true; });
        setShowQuantityAdjustedBanner(hasQuantityAdjustments || false);
        var newSelectedArray = [];
        var newVariantIdObject = {};
        var newProductIdObject = {};
        var productMap = {}; // Map to avoid duplicate products
        cartData.CartProductDetails.forEach(function (cartItem) {
            var variantId = cartItem.id || cartItem.variantId || cartItem.VariantId; // Get variant ID from various possible fields
            var quantity = cartItem.OriginalQuantity !== undefined ? cartItem.OriginalQuantity : cartItem.Quantity !== undefined ? cartItem.Quantity : cartItem.quantity || 1; // Prefer OriginalQuantity, fallback to Quantity/quantity
            if (!variantId)
                return;
            var normalizedVariantId = normalizeVariantId(variantId); // Normalize variant ID
            if (normalizedVariantId === null)
                return;
            var foundProduct = null;
            var foundVariant = null;
            for (var _i = 0, _a = salesRepData.productsData || []; _i < _a.length; _i++) {
                var product = _a[_i];
                for (var _b = 0, _c = product.variants || []; _b < _c.length; _b++) {
                    var variant = _c[_b];
                    var normalizedVariantIdFromProduct = normalizeVariantId(variant.variantId); // Normalize product variant ID
                    if (normalizedVariantIdFromProduct === normalizedVariantId || variant.variantId === variantId) {
                        foundProduct = product; // Match found
                        foundVariant = variant;
                        break;
                    }
                }
                if (foundProduct)
                    break; // Exit outer loop if found
            }
            if (foundProduct && foundVariant) {
                var productId = foundProduct.productId;
                if (!productId)
                    return;
                var normalizedVariantIdForObject_1 = normalizeVariantId(foundVariant.variantId);
                if (normalizedVariantIdForObject_1 === null)
                    return;
                newVariantIdObject[normalizedVariantIdForObject_1] = quantity; // Set quantity for variant
                if (!productMap[productId]) {
                    productMap[productId] = __assign(__assign({}, foundProduct), { variants: [] }); // Add product to map
                    newProductIdObject[productId] = productId; // Track product ID
                }
                if (!productMap[productId].variants.some(function (v) { return normalizeVariantId(v.variantId) === normalizedVariantIdForObject_1; })) {
                    productMap[productId].variants.push(foundVariant); // Add variant if not duplicate
                }
            }
            else {
                if (!isNaN(normalizedVariantId))
                    newVariantIdObject[normalizedVariantId] = quantity; // Add variant even if product not found
            }
        });
        Object.values(productMap).forEach(function (product) { return newSelectedArray.push(product); }); // Convert map to array
        setNewSelectedArray(newSelectedArray); // Set selected products
        setVariant_idObject(newVariantIdObject); // Set variant quantities
        setProduct_idObject(newProductIdObject); // Set product IDs
        setIsEditMode(true); // Enable edit mode
        setEditingCart(cartData); // Store cart data being edited
    };
    var clearEditMode = function () {
        setIsEditMode(false); // Exit edit mode
        setEditingCart(null); // Clear editing cart
        setCartName(""); // Clear cart name
        setNewSelectedArray([]); // Clear selections
        setVariant_idObject({}); // Clear variant quantities
        setProduct_idObject({}); // Clear product IDs
        setShowQuantityAdjustedBanner(false); // Clear quantity adjustment banner
    };
    var updateSharedCart = function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, createSharedCart()];
                case 1: return [2 /*return*/, _a.sent()]; // Update uses same logic as create (handled by isEditMode flag)
            }
        });
    }); };
    // Check if any products have adjusted quantities (quantity exceeds inventory or product not available)
    var hasQuantityAdjusted = function () {
        if (!NewselectedArray || NewselectedArray.length === 0)
            return false;
        return NewselectedArray.some(function (product) {
            if (!product.variants || !Array.isArray(product.variants))
                return false;
            return product.variants.some(function (variant) {
                var variantId = variant.variantId;
                var normalizedVariantId = normalizeVariantId(variantId);
                if (normalizedVariantId === null)
                    return false;
                // Check both normalized and original variant ID
                var selectedQuantity = variant_idObject[normalizedVariantId] || variant_idObject[variantId] || 0;
                var quantityAvailable = variant.quantityAvailable;
                var availableForSale = variant.availableForSale;
                // Check if product is not available for sale
                if (!availableForSale && selectedQuantity > 0)
                    return true;
                // Check if quantity exceeds available inventory (if inventory is tracked)
                if (quantityAvailable !== null && quantityAvailable !== undefined && typeof quantityAvailable === "number") {
                    if (selectedQuantity > quantityAvailable)
                        return true;
                }
                return false;
            });
        });
    };
    return {
        t: t,
        shopCurrency: shopCurrency,
        currency: currency,
        shareCartData: shareCartData,
        deleteSharedCartLink: deleteSharedCartLink,
        deleteLink: deleteLink,
        cartName: cartName,
        setCartName: setCartName,
        products: products,
        SearchProduct: SearchProduct,
        renderImageSrc: renderImageSrc,
        searchProductInput: searchProductInput,
        setSearchProductInput: setSearchProductInput,
        product_idObject: product_idObject,
        backToShopBtn: backToShopBtn,
        handleBackToShopBtn: handleBackToShopBtn,
        handleSelectedBtn: handleSelectedBtn,
        variant_idObject: variant_idObject,
        createSharedCart: createSharedCart,
        createdCartMsg: createdCartMsg,
        handleQuantity_IncrementDecrement: handleQuantity_IncrementDecrement,
        checkUncheck: checkUncheck,
        NewselectedArray: NewselectedArray,
        handleAlertMsgClose: handleAlertMsgClose,
        alertMsgOpen: alertMsgOpen,
        deleteConfirmation: deleteConfirmation,
        openDeleteConfirmation: openDeleteConfirmation,
        setDeleteConfirmation: setDeleteConfirmation,
        CreateCartBtnDisabled: CreateCartBtnDisabled,
        isNotEmpty: isNotEmpty,
        deleteShareCartDataObject: deleteShareCartDataObject,
        handleProductQuantity: handleProductQuantity,
        isError: isError,
        isMobile: isMobile,
        alertErrorMsg: alertErrorMsg,
        setAlertErrorMsg: setAlertErrorMsg,
        productsLoading: productsLoading,
        cartSharingInnerScroll: cartSharingInnerScroll,
        cartSharingProductsRowsPerPage: cartSharingProductsRowsPerPage,
        setOpenSearchProducts: setOpenSearchProducts,
        openSearchProducts: openSearchProducts,
        disableCreateCartBtn: disableCreateCartBtn,
        setIsRemoveSelectedProduct: setIsRemoveSelectedProduct,
        isRemoveSelectedProduct: isRemoveSelectedProduct,
        setIsRemoveCartPopup: setIsRemoveCartPopup,
        isRemoveCartPopup: isRemoveCartPopup,
        getSharedCartDetailsById: getSharedCartDetailsById,
        previewCartDetails: previewCartDetails,
        previewLoading: previewLoading,
        isEditMode: isEditMode,
        editingCart: editingCart,
        populateFormWithCartData: populateFormWithCartData,
        clearEditMode: clearEditMode,
        updateSharedCart: updateSharedCart,
        menuAnchor: menuAnchor,
        setMenuAnchor: setMenuAnchor,
        previewCart: previewCart,
        setPreviewCart: setPreviewCart,
        openPreview: openPreview,
        setOpenPreview: setOpenPreview,
        quantityAdjustedWarningOpen: quantityAdjustedWarningOpen,
        setQuantityAdjustedWarningOpen: setQuantityAdjustedWarningOpen,
        showQuantityAdjustedBanner: showQuantityAdjustedBanner,
        setShowQuantityAdjustedBanner: setShowQuantityAdjustedBanner,
    };
}
export function CssConstantObjects() {
    var isMobile = useDeviceQueries();
    var ST_CS_tableDataCell = {
        pt: 0.5,
        pb: 0.5,
    };
    var ST_CS_OrderNotesGrid = {
        maxWidth: isMobile ? "100% !important" : "300px !important",
        minWidth: isMobile ? "100% !important" : "264px !important",
        mt: 2,
    };
    var ST_CS_DisplayFlex = {
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-between",
        mb: isMobile ? 1 : 3,
        mt: isMobile ? 1 : 3,
        alignItems: "center",
    };
    var ST_CS_Display_ShareCart = {
        width: isMobile ? "100%" : "115px",
    };
    var ST_CS_AddMoreProducts_Btn = {
        mr: 1,
        mt: 2,
        whiteSpace: "nowrap",
    };
    var ST_CS_SearchProductGrid = {
        mt: 2,
    };
    return { ST_CS_tableDataCell: ST_CS_tableDataCell, ST_CS_OrderNotesGrid: ST_CS_OrderNotesGrid, ST_CS_DisplayFlex: ST_CS_DisplayFlex, ST_CS_AddMoreProducts_Btn: ST_CS_AddMoreProducts_Btn, ST_CS_SearchProductGrid: ST_CS_SearchProductGrid, ST_CS_Display_ShareCart: ST_CS_Display_ShareCart };
}
